import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import "../daily-plan-input/dailyPlanInput.css";

function DayPlanInput({ postRoute, onSuccess }) {
  const { trip_id } = useParams();
  const [errorMessage, setErrorMessage] = useState(null);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    try {
      const payload = { ...data, trip_id };
      const response = await axios.post(postRoute, payload);
      if (onSuccess) onSuccess("Day plan added successfully.");
    } catch (err) {
      console.error("Error:", err);
      setErrorMessage(err.response?.data?.error || "Unexpected error.");
    }
  };

  return (
    <div className="dayplan-input-container">
      <div className="dayplan-title">
        <p className="dayplan-heading">New Day Plan</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="dayplan-detail">
        <div className="dayplan-label-container">
          <label className="dayplan-label">Name:</label>
          <input
            placeholder="Name"
            {...register("name")}
            className="dayplan-text"
          />
        </div>

        <div className="dayplan-label-container">
          <label className="dayplan-label">Information:</label>
          <textarea
            placeholder="Information"
            {...register("information")}
            className="dayplan-text"
          />
        </div>

        <div className="dayplan-label-container">
          <label className="dayplan-label">Date:</label>
          <input type="date" {...register("date")} className="dayplan-text" />
        </div>

        <div className="dayplan-label-container">
          <label className="dayplan-label">Time:</label>
          <input type="time" {...register("time")} className="dayplan-text" />
        </div>

        <div className="dayplan-label-container">
          <label className="dayplan-label">Address:</label>
          <textarea
            placeholder="Address"
            {...register("address")}
            className="dayplan-text"
          />
        </div>

        {errorMessage && <p className="error">{errorMessage}</p>}

        <button type="submit" className="dayplan-button">
          Save Day Plan
        </button>
      </form>
    </div>
  );
}

export default DayPlanInput;
